import { useEffect } from 'react';
import { useSession } from '@erikdakoda/auth/client/betterAuthClient';
import { applySentryUser } from '@erikdakoda/log/applySentryUser';

/**
 * Keeps the Sentry scope user aligned with the Better Auth session after the
 * session query has finished loading.
 * @returns Renders nothing
 */
export default function SentryUserSync(): null {
  'use memo';

  const { data: session, isPending } = useSession();

  useEffect(() => {
    if (isPending) {
      return;
    }
    applySentryUser(session?.user ?? null);
  }, [isPending, session?.user]);

  return null;
}
